<template>
    <div class="ts-overflow-scroll ts-max-h-screen">
        <ts-table :columns="columns" :records="totalShops">
            <template v-slot="{ record }">
                <td style="vertical-align: middle;">
                    {{ record.shop_code || " " }}
                </td>
                <td style="vertical-align: middle;">
                    {{ record.shop_name || " " }}
                </td>
                <td style="vertical-align: middle;">
                    {{ record.phone_number|| " " }}
                </td>
                <td style="vertical-align: middle;">
                    {{ record.address_1 || " " }}
                </td>
                <td style="vertical-align: middle;">
                    {{ record.business_category || " " }}
                </td>
                     <td style="vertical-align: middle;">
                    {{ record.shop_type || " " }}
                </td>
            </template>
        </ts-table>
    </div>
</template>
<script>
export default {
    name: "viewShopList",
    props: ["totalShops"],
    data() {
        return {};
    },
    computed: {
        columns() {
            return [
                {
                    name: this.$t("zone.shopCode")
                },
                {
                    name: this.$t("zone.shopName")
                },
                {
                    name: this.$t("zone.phone")
                },
                {
                    name: this.$t("zone.shopAddress")
                },
                {
                    name: this.$t("zone.businessCategory")
                },
                {
                    name: this.$t("zone.shopType")
                }
            ];
        }
    }
};
</script>

<style lang="css" scoped>
table {
    width: 100%;
    border-collapse: collapse;
}
table thead tr th {
    text-transform: uppercase;
    padding: 4px 7px;
    background: rgb(218, 218, 218);
}
table tbody tr td {
    padding: 4px 7px;
}
</style>
